import { AGENTS, HOUSES, RULES, VENDORS } from '../config/competition'
import { compactMoney } from '../core/format'
import type { CompetitionState } from '../core/types'
import { AgentAvatar } from './primitives/Media'
import { Panel } from './primitives/Panel'

/**
 * The pre-flight box on the public board. Deliberately has no control on it --
 * the round is opened from the operator console at #/admin.
 */
export function StartPanel({ state }: { state: CompetitionState }) {
  const pricesLive = state.meta.prices === 'live'

  return (
    <Panel title="ROUND CONTROL" grow className="start" note={<span className="u-label">STANDBY</span>}>
      <div className="start__body">
        <p className="start__eyebrow">ROUND {String(state.meta.round).padStart(2, '0')}</p>
        <h1 className="start__title">COMPETITION STARTING SOON</h1>
        <p className="start__blurb">
          Four agents. Two houses. {compactMoney(RULES.seedCapital)} of capital each and{' '}
          {RULES.durationHours} hours to prove something. The tape opens when the round is
          started.
        </p>

        <ul className="start__roster">
          {AGENTS.map((a) => (
            <li key={a.id} className="entrant" style={{ ['--accent' as string]: a.color }}>
              <AgentAvatar agentId={a.id} size={26} />
              <span className="entrant__name">{a.name}</span>
              <span className="entrant__meta">
                {HOUSES[a.house].name} · {VENDORS[a.vendor].short}
              </span>
            </li>
          ))}
        </ul>

        <p className="start__foot">
          <span className={pricesLive ? 'u-up' : 'u-flat'}>
            {pricesLive ? 'PRICE FEED CONNECTED' : 'CONNECTING PRICE FEED'}
          </span>
          <span className="u-flat">AGENTS ARMED</span>
        </p>
      </div>
    </Panel>
  )
}
